// extracted by mini-css-extract-plugin
module.exports = {"loading-spinner":"_3xY3Ij57PNXbM91aiuJvfM"};